module.exports = __webpack_public_path__ + "fonts/31E180_1_0.986a6c3.eot";